import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../../layout/theme-next/provider';
import { grayDotStyles, lineItemStyles } from '../../../common/styles';

export default makeStyles((theme: NextTheme) => ({
  ...lineItemStyles(theme),
  ...grayDotStyles(theme, {
    right: 4,
    marginLeft: 4,
    marginRight: 5,
  }),
  innerWrap: {
    display: 'inline-flex',
  },
  truncateMobile: {
    overFlow: 'unset',
  },
  [theme.media.mobile]: {
    innerWrap: {
      display: 'block',
    },
    truncateMobile: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      wordBreak: 'break-all',
    },
  },
}));
